<template>
  <EditItemForm :con="con" :editedItem="editedItem" @closed="close">
    <template v-slot:dialog-text="{ item }">
      <v-container>
        <v-row>
          <v-col cols="4">
            <image-to-base-64
              :maxSize="150 / 1024"
              :preview="item.imageBase64"
              @file-info="receiveFileInfo"
              @size-error="sizeError"
              @type-error="typeError"
            />
          </v-col>
          <v-col/>                    
          <v-col cols="4">
            <v-switch
              v-model="item.partialCap"
              :label="$t('crudRooms.fieldPartial')"
              color="red"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <v-autocomplete
              v-model="item.locationId"
              :items="locations"
              item-value="id"
              item-text="city"
              :label="$t('crudUser.locationUser')"
              :rules="rules.emptyField"
              required
              persistent-hint
              single-line
              color="grey"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="item.name"
              :label="$t('crudCentre.NameCenter')"
              :rules="rules.inputText"
              required
              color="grey"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="item.phoneNumber"
              :label="$t('crudCentre.phoneNumber')"
              required
              :rules="rules.inputPhoneNumber"
              color="grey"
              counter="10"
              max-errors="10"
            />
          </v-col>
        </v-row>
      </v-container>
    </template>
  </EditItemForm>
</template>

<script>
import EditItemForm from "../EditItemForm";
import imageToBase64 from "@/components/components-base/image/imageToBase64";
import rules from "@/models/InputRules";
import i18n from "@/i18n";
import { mapGetters } from "vuex";

export default {
  name: "EditCenterForm",
  components: {
    EditItemForm,
    imageToBase64,
  },
  props: {
    con: null,
    editedItem: null,
  },
  data: () => ({
    rules: rules,
  }),
  computed: {
    ...mapGetters("locationModule", { locations: "getLocations" }),
  },
  methods: {
    close() {
      this.$emit("closed");
    },
    receiveFileInfo(fileInfo) {
      if (fileInfo) {
        this.fileInfo = fileInfo;
        this.uploadImage();
      }
    },
    sizeError() {
      alert(i18n.t("imageToBase64.errorImageSize"));
    },
    typeError() {
      alert(i18n.t("imageToBase64.errorImageFormat"));
    },
    uploadImage() {
      if (this.fileInfo && this.editedItem != null)
        this.editedItem.imageBase64 = this.fileInfo.base64;
    },
  },
};
</script>
